import axios from 'axios';

import { ITermin, TerminCriteria } from '@/shared/model/termin.model';
import { IPferd } from '@/shared/model/pferd.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/termins';

export default class TerminService {

  public setPayed(id: number, payed: boolean) {
    axios.post(`${baseApiUrl}Payed/${id}/${payed}`);
  }

  public setStorno(id: number): Promise<ITermin> {
    return new Promise<ITermin>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}Storno/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAll(id: number): Promise<ITermin> {
    return new Promise<ITermin>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}All/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<ITermin> {
    return new Promise<ITermin>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(req?: any, criteria?: TerminCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}Filter?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public retrieveByCriteria(criteria: TerminCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}FilterCriteria`, criteria);
  }

  public retrieveAllUsers(req?: any, criteria?: TerminCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}FilterAll?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public retrieveByCriteriaAllUsers(criteria: TerminCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}FilterCriteriaAll`, criteria);
  }

  public retrieveByPferd(pferd: IPferd): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/pferd/${pferd.id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ITermin): Promise<ITermin> {
    return new Promise<ITermin>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ITermin): Promise<ITermin> {
    return new Promise<ITermin>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
